const type = 'RESET_STATEMENTS';

const resetStatements = () => ({
  type,
});

export { type };
export default resetStatements;
